import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, CountryFlag, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import CountryExtraFields from '../CountryExtraFields/CountryExtraFields'
import { getCountryExtraFields, getEuropeanUnionExtraFields } from '../CountryExtraFields/helpers'
import { isMissingExportPrice } from '../helpers'
import ManufacturerFields from '../ManufacturerFields/ManufacturerFields'
import * as Styles from './styles'

const ExportCountryBlock = ({
  block,
  exportPrice,
  taricCode,
  hsCode,
  currencies,
  manufacturerName,
  manufacturerAddress,
  onChange,
  onChangeTaricCode,
  onChangeManufacturer,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleChangeTaricCode = (field, value) => onChangeTaricCode(value)

  const handleChangePrice = e => onChange('price', e.target.value || null)

  const handleChangePriceCurrency = e => onChange('price_currency', e.target.value)

  const name = block.isEuropeanUnion ? t('Unión Europea') : block.name
  const isExportPriceMissing = isMissingExportPrice(exportPrice)

  return (
    <Styles.Container>
      <Styles.Header>
        <CountryFlag code={block.code} />
        <Text type="bodyMBold">{name}</Text>
      </Styles.Header>
      {block.isEuropeanUnion && (
        <CountryExtraFields
          fields={getEuropeanUnionExtraFields(hsCode)}
          values={{ taric_code: taricCode }}
          onChange={handleChangeTaricCode}
          countryName={name}
        />
      )}
      {!block.isEuropeanUnion && block.showCustomsCode && (
        <CountryExtraFields
          fields={getCountryExtraFields(block.code, hsCode)}
          values={exportPrice}
          onChange={onChange}
          countryName={name}
        />
      )}
      {block.showManufacturer && (
        <ManufacturerFields name={manufacturerName} address={manufacturerAddress} onChange={onChangeManufacturer} />
      )}
      {block.showExportPrice && (
        <Styles.Row>
          <InputWithLabel
            label={t('Precio de exportación')}
            type="number"
            value={Number(exportPrice?.price) || ''}
            onChange={handleChangePrice}
            backgroundColor={theme.colors.background.primary}
            fullWidth
            error={isExportPriceMissing}
            InputLabelProps={{ error: false, focused: isExportPriceMissing ? false : undefined }}
            helperText={
              isExportPriceMissing &&
              t('No se puede declarar el valor en aduana para {{country}}. Los envíos pueden quedar retenidos.', {
                country: name,
              })
            }
          />
          <ComboBox
            label={t('Divisa')}
            value={exportPrice?.price_currency}
            handleChange={handleChangePriceCurrency}
            menuItems={currencies?.map(currency => ({ label: currency.name, value: currency.code }))}
            backgroundColor={theme.colors.background.primary}
            fullWidth
          />
        </Styles.Row>
      )}
    </Styles.Container>
  )
}

export default ExportCountryBlock
